import { render, staticRenderFns } from "./TemplateFontEditForm.vue?vue&type=template&id=11878216"
import script from "./TemplateFontEditForm.vue?vue&type=script&lang=js"
export * from "./TemplateFontEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports